module.exports = __webpack_public_path__ + "static/media/design1.e39c7e29.png";